import { dataMigrateSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMigrateSolid = /*#__PURE__*/createIcon(dataMigrateSolid)
export default IconMigrateSolid
